// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3MCar","productName":"Table_productName__2FVy_"};